import {getField, updateField} from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    company: {},
    showHistory: false
};

const mutations = {
    updateField,

    setCompany(state, company) {
        state.company = company;
    },

    showHistory(state, flag) {
        state.showHistory = flag;
    },
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};